import { render, staticRenderFns } from "./affiliatedEnterprise.vue?vue&type=template&id=1893b0f9"
import script from "./affiliatedEnterprise.vue?vue&type=script&lang=js"
export * from "./affiliatedEnterprise.vue?vue&type=script&lang=js"
import style0 from "./affiliatedEnterprise.vue?vue&type=style&index=0&id=1893b0f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports